import Vue from 'vue'

async function requestWithRetry(requestFunction, maxRetries = 3) {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await requestFunction()
    } catch (error) {
      console.log(`Attempt ${attempt} failed:`, error)
      if (attempt === maxRetries) {
        console.log(`Maximum retries reached: ${attempt}`, error)
      }
    }
  }
}

export default {
  listCompetitors({ companyId }) {
    const request = () => Vue.http.get(`api/v1/ovation/competitors/${companyId}/list`)
    return requestWithRetry(request)
  },
  fetchFeedbackData({ filters, search, limit, skip }) {
    const { createdAtRange, ...restFilters } = filters
    const request = () =>
      Vue.http.post('api/v1/ovation/competitors/list', {
        filters: {
          ...restFilters,
          timestampRange: createdAtRange,
          ...(filters.sentiment && { sentiment: [filters.sentiment] })
        },
        search,
        limit,
        skip
      })
    return requestWithRetry(request)
  },
  fetchBreakdown({ filters, search }) {
    const { createdAtRange, ...restFilters } = filters
    const request = () =>
      Vue.http.post('api/v1/ovation/competitors/breakdown', {
        filters: {
          ...restFilters,
          timestampRange: createdAtRange,
          ...(filters.sentiment && { sentiment: [filters.sentiment] })
        },
        ...(search && { search })
      })
    return requestWithRetry(request)
  },
  fetchSummaries({ filters, search }) {
    const { createdAtRange, ...restFilters } = filters
    const request = () =>
      Vue.http.post('api/v1/ovation/competitors/ai-summary', {
        filters: {
          ...restFilters,
          timestampRange: createdAtRange,
          ...(filters.sentiment && { sentiment: [filters.sentiment] })
        },
        search
      })
    return requestWithRetry(request)
  }
}
